import axios from "axios";
import { Toast } from "@douyinfe/semi-ui";

// 与 vite.config 中的 VITE_API_BASE_URL 保持一致，默认 "/api"
const API_BASE = import.meta.env.VITE_API_BASE_URL || "/api";

// 创建 axios 实例
export const http = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
});

// 请求拦截：自动携带 token
http.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 如果是 FormData，不设置 Content-Type，让浏览器自动设置（包含 boundary）
    if (!(config.data instanceof FormData) && !config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截：统一处理 success 标记和错误 Toast
http.interceptors.response.use(
  (response) => {
    // 如果是 blob 响应（文件下载），直接返回 blob
    if (
      response.config.responseType === "blob" ||
      response.data instanceof Blob
    ) {
      // 检查是否是错误响应（后端可能返回 JSON 格式的错误信息）
      if (
        response.data.type &&
        response.data.type.includes("application/json")
      ) {
        // 错误响应是 JSON，需要解析
        return response.data.text().then((text) => {
          try {
            const errorData = JSON.parse(text);
            if (errorData.success === false) {
              const msg = errorData.message || "请求失败";
              Toast.error(msg);
              const err = new Error(msg);
              return Promise.reject(err);
            }
          } catch (e) {
            // 解析失败，返回原始 blob
            return response.data;
          }
        });
      }
      return response.data;
    }

    const data = response.data;
    if (data && data.success === false) {
      const msg = data.message || "请求失败";
      Toast.error(msg);
      const err = new Error(msg);
      return Promise.reject(err);
    }
    return data;
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response;

      // 处理 blob 类型的错误响应
      if (
        data instanceof Blob &&
        data.type &&
        data.type.includes("application/json")
      ) {
        return data.text().then((text) => {
          try {
            const errorData = JSON.parse(text);
            const msg = errorData?.message || error.message || "请求失败";
            Toast.error(msg);
            const err = new Error(msg);
            err.status = status;
            return Promise.reject(err);
          } catch (e) {
            const msg = error.message || "请求失败";
            Toast.error(msg);
            const err = new Error(msg);
            err.status = status;
            return Promise.reject(err);
          }
        });
      }

      const msg = data?.message || error.message || "请求失败";

      Toast.error(msg);

      if (status === 401) {
        // 清理本地登录态并跳转
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }

      const err = new Error(msg);
      err.status = status;
      return Promise.reject(err);
    }

    const msg = error.message || "网络异常";
    Toast.error(msg);
    const err = new Error(msg);
    return Promise.reject(err);
  }
);
